module.exports = __webpack_public_path__ + "static/footer-logo-c895a99c654d86f954be0a9e41044ad0.png";